export default __webpack_public_path__ + "static/media/SAL3.a181c1f6.jpg";